import React, {Component} from 'react';

import {Parser} from 'html-to-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {FONTS} from 'Frontend/utils/fonts';
import {clampCss, pxToVw} from 'Frontend/utils/helpers';
import {MEDIA} from 'Frontend/utils/mediaQueries';
import {isValidNode, processingInstructions} from 'Frontend/utils/parserInstructions';

/**
 * AccordionVideo
 *
 * @property {*} prop Prop comment.
 *
 * @class AccordionVideo
 * @extends {Component}
 */
class AccordionVideo extends Component {
    static propTypes = {contents: PropTypes.array.isRequired}

    htmlParser = new Parser();

    /**
     * Renders the Component.
     *
     * @returns {JSX} Component.
     * @memberof AccordionVideo
     */
    render() {
        const {contents} = this.props;

        return (
            <AccordionVideoElement>
                {contents.map(item => {
                    const {copy, video} = item;

                    return (
                        <RowContainer key={copy}>
                            <VideoSizeWrap>
                                <Video>
                                    {this.htmlParser.parseWithInstructions(
                                        video,
                                        isValidNode,
                                        processingInstructions
                                    )}
                                </Video>
                            </VideoSizeWrap>
                            <VideoCopyContainer>
                                <Text>
                                    {this.htmlParser.parseWithInstructions(
                                        `<div data-module="VideoContent">${copy}</div>`,
                                        isValidNode,
                                        processingInstructions
                                    )}
                                </Text>
                            </VideoCopyContainer>
                        </RowContainer>
                    );
                })}
            </AccordionVideoElement>
        );
    }
}

export default AccordionVideo;

const AccordionVideoElement = styled.div`
    margin-top: ${clampCss(7, 'm')};
`;

const RowContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: ${clampCss(48, 'm')};

    &:last-child {
        margin-bottom: ${clampCss(26, 'm')};
    }
`;

const VideoSizeWrap = styled.div`
    width: 100%;
`;

const Video = styled.div`
    align-items: center;
    background: black;
    border-radius: ${clampCss(8, 'm')};
    display: flex;
    justify-content: center;
    overflow: hidden;
    padding-top: 56.25%;
    position: relative;
    width: 100%;

    & > iframe {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
    }
`;

const VideoCopyContainer = styled.div`
    width: 100%;
`;

const Text = styled.div`
    ${FONTS.REGULAR}
    color: ${({theme}) => theme.colors.textColor};
    font-size: ${clampCss(12, 'm')};
    letter-spacing: ${clampCss(0.5, 'm')};
    line-height: ${clampCss(16.8, 'm')};
    margin-top: ${clampCss(24, 'm')};
    text-align: left;

    ${MEDIA.TABLET.UP} {
        font-size: ${clampCss(12, 't')};
        letter-spacing: ${clampCss(0.5, 't')};
        line-height: ${clampCss(16.8, 't')};
        margin-top: ${clampCss(24, 't')};
    }

    ${MEDIA.DESKTOP.UP} {
        font-size: max(14px, ${pxToVw(14, 'd')});
        letter-spacing: max(0.5px, ${pxToVw(0.5, 'd')});
        line-height: max(19.6px, ${pxToVw(19.6, 'd')});
        margin-top: max(32px, ${pxToVw(32, 'd')});
    }
`;